import { FeatureInfoControl } from "../controls/FeatureInfoControl";
import { markMemberRows } from "../featureinfo/entryGlue.js";
import { onPointerOntoControls } from "../util/hoverOverControls.mjs";

export function addFeatureInfoControl(map) {
  const featureInfoControl = new FeatureInfoControl();
  map.addControl(featureInfoControl);
  map.on("singleclick", function () {
    const allHoverLayers = featureInfoControl.getAllHoverLayers();
    allHoverLayers.forEach((hoverLayer) => hoverLayer.getSource().clear());
    featureInfoControl.unset("selectedFeaturesAndLayers");
  });
  // Onto the sidebar, drawer or hover box: the moves below stop at the canvas check,
  // so the last hover would stay drawn.
  const clear = () => {
    featureInfoControl.clearHover();
    markMemberRows(new Set());
  };
  onPointerOntoControls(map, clear);
  // Out of the window: no further pointermove would clear the last hover.
  map.getViewport().addEventListener("pointerleave", clear);
  map.on("pointermove", function (e) {
    const featuresAtPixel = [];
    if (e.originalEvent.target.tagName !== "CANVAS") {
      return;
    }
    const allHoverLayers = featureInfoControl.getAllHoverLayers();
    map.forEachFeatureAtPixel(
      e.pixel,
      (feature, layer) => {
        if (feature.get("nonInteractive")) return;
        featuresAtPixel.push({ feature: feature, layer: layer });
      },
      {
        layerFilter: (layer) => !allHoverLayers.includes(layer),
      },
    );
    // Position silently, then the selection: one hover update per move, at the new
    // position (setProperties fired two, the first at the old position).
    featureInfoControl.set("position", e.coordinate, true);
    featureInfoControl.set("selectedFeaturesAndLayers", featuresAtPixel);
    // Mark sidebar member rows of the features under the pointer, in every row.
    markMemberRows(
      new Set(featuresAtPixel.map(({ feature }) => String(feature.getId()))),
    );
  });
  return featureInfoControl;
}
